import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ShieldIcon from '@mui/icons-material/Shield';

function SecuritySection() {
  const securities = [
    { 
      icon: <LockIcon />, 
      title: 'Encrypted Transactions', 
      desc: '256-bit SSL and blockchain verification for every transaction, ensuring complete data protection and privacy.'
    },
    { 
      icon: <VpnKeyIcon />, 
      title: 'Private Key Access', 
      desc: 'Your digital assets are secured with unique, private keys and multi-signature wallets for enhanced security.'
    },
    { 
      icon: <ShieldIcon />, 
      title: 'Physical Vaulting', 
      desc: 'Physical assets stored in fully insured, high-security vaults with comprehensive global coverage.'
    }
  ];

  return (
    <Box sx={{ 
      py: { xs: 8, md: 12 }, 
      backgroundColor: '#111111', 
      borderTop: '1px solid rgba(192, 192, 192, 0.1)', 
      borderBottom: '1px solid rgba(192, 192, 192, 0.1)' 
    }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontFamily: "'Playfair Display', serif",
              color: '#ffffff',
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              mb: 2,
            }}
          >
            Unmatched Security
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: '#a1a1a1',
              textAlign: 'center',
              maxWidth: '800px',
              mx: 'auto',
              lineHeight: 1.8,
            }}
          >
            Our financial and physical assets are protected with state-of-the-art encryption, 
            multi-signature wallets, and insured vault services worldwide.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {securities.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box sx={{ 
                textAlign: 'center',
                p: 3,
                borderRadius: '6px',
                border: '1px solid rgba(192, 192, 192, 0.05)',
                transition: 'all 0.4s ease',
                height: '100%',
                '&:hover': {
                  borderColor: 'rgba(212, 175, 55, 0.2)',
                  backgroundColor: 'rgba(212, 175, 55, 0.02)',
                }
              }}>
                <Box sx={{ 
                  color: '#c0c0c0', 
                  fontSize: '4rem', 
                  mb: 2, 
                  '& svg': { fontSize: '4rem' } 
                }}>
                  {item.icon}
                </Box>
                
                <Typography variant="h6" sx={{ 
                  color: '#ffffff', 
                  mb: 1, 
                  fontFamily: "'Playfair Display', serif" 
                }}>
                  {item.title}
                </Typography>
                
                <Typography variant="body2" sx={{ 
                  color: '#a1a1a1', 
                  maxWidth: '300px', 
                  mx: 'auto', 
                  lineHeight: 1.7 
                }}>
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default SecuritySection;